module.exports = __webpack_public_path__ + "media/goforajourney/img/madrid-tour-c71c8749bf7920ab9bfd5416d20e14fe.webp";